<div
  class="tab-group"
  [ngClass]="{ 'tab-group__white-selection': whiteSelection }"
>
  <mat-tab-group
    (selectedIndexChange)="changeTab($event)"
    [(selectedIndex)]="currentTabIndex"
  >
    <mat-tab *ngFor="let tab of tabs">
      <ng-template mat-tab-label>
        <div class="flex justify-start items-center gap-2">
          <div class="flex justify-center items-center">
            <mat-icon
              *ngIf="!tab.icon.isSvg"
              [fontSet]="tab.icon.fontSet"
              class="mr-2"
            >
              {{ tab.icon.name }}
            </mat-icon>
            <mat-icon
              *ngIf="tab.icon.isSvg"
              [svgIcon]="tab.icon.name"
              class="mr-2"
            ></mat-icon>
          </div>
          <div class="flex flex-col text-start">
            <div class="tab-group__name w-full tab-bar-title">
              {{ tab.title }}
            </div>
            <div class="w-full tab-bar-subtitle">{{ tab.subtitle }}</div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
